import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { RegistrationWithCepAction } from "./registration-with-cep.action";
import { RegistrationWithCepService } from "./registration-with-cep.service";

@Injectable()
export class RegistrationWithCepEffect {
	getAddressByCep$: Observable<Action> = createEffect(() =>
		this.actions$.pipe(
			ofType(RegistrationWithCepAction.getAddressByCep),
			switchMap((x) =>
				this.registrationWithCepService.getAddressByCep(x.cep).pipe(
					map((response) => RegistrationWithCepAction.getAddressByCepSuccess(response)),
					catchError((error) => of(RegistrationWithCepAction.getAddressByCepFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private registrationWithCepService: RegistrationWithCepService
	) {}
}
